import React, { Component } from 'react';
import icons_80 from '../../assets/images/icons-section_80.png';
import icons_40 from '../../assets/images/icons-section_40.png';
import IconSet from './IconSet';

class IconSetSection extends Component {
  render() {
    const items = ['home', 'recruitment', 'recruit', 'company', 'sample', 'units', 'team', 'ethic', 'about', 'contact', 'chevron'];
    const sets = { 'size_80': icons_80, 'size_40': icons_40};
    return <IconSet  items={items} size={80} sets={sets} {...this.props} />
  }
}

export default IconSetSection;



// WEBPACK FOOTER //
// ./src/components/Icon/IconSetSection.jsx